export default __webpack_public_path__ + "static/kari2-d5eb8dd5bb791f17105317a5c273f540.jpg";